export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  if ('serviceWorker' in navigator) {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // Ignore SW registration failures (insecure origin, blocked, etc.)
    })
  }

  const deferredPrompt = useState<Event | null>('pwa-deferred-prompt', () => null)
  const standalone = useState('pwa-standalone', () => false)

  const nav = window.navigator as Navigator & { standalone?: boolean }
  standalone.value = Boolean(nav.standalone)
    || window.matchMedia('(display-mode: standalone)').matches

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault()
    deferredPrompt.value = event
  })

  window.addEventListener('appinstalled', () => {
    deferredPrompt.value = null
    standalone.value = true
  })
})
